import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Program } from '@model';
import { GridProgramService } from '@service';

/**
 * @deprecated
 */
@Injectable()
export class ScenarioViewResolver {
  constructor(private gridProgramService: GridProgramService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line prettier/prettier
  ): Observable<[Program[], Program[]]> {
    const scenarioId =
      route.queryParamMap.get('scenarioId') || route.paramMap.get('scenarioId');
    if (!scenarioId) {
      return of([[], []]);
    }

    const programsDetail$ = this.gridProgramService.programsDetail$(scenarioId);
    const customPrograms$ = this.gridProgramService.customPrograms$(scenarioId);
    const programMeta$ = this.gridProgramService.programMeta$(scenarioId);

    return forkJoin([programsDetail$, customPrograms$, programMeta$]).pipe(
      map(([programs, customPrograms, metas]) => {
        const enrichWithMeta = (programList: Program[]): Program[] => {
          return programList.map(program => {
            const meta = metas.find(m => m.programId === program.id);
            return {
              ...program,
              isCustomEvents: meta ? meta.customEvents : false,
            };
          });
        };

        return [enrichWithMeta(programs), enrichWithMeta(customPrograms)];
      })
    );
  }
}
